// extracted by mini-css-extract-plugin
module.exports = {"app__footer":"v_bz","app__footer__copyFoot":"v_bB"};